// extracted by mini-css-extract-plugin
export default {"videoContainer":"social-dmo-sponsored-right-rail-module-DmoVideoCard__videoContainer--2wCep","caption":"social-dmo-sponsored-right-rail-module-DmoVideoCard__caption--acVv1"};